import { render } from "./VillageFriends.vue?vue&type=template&id=17df0a24&scoped=true"
import script from "./VillageFriends.vue?vue&type=script&lang=js"
export * from "./VillageFriends.vue?vue&type=script&lang=js"

import "./VillageFriends.vue?vue&type=style&index=0&id=17df0a24&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17df0a24"]])

export default __exports__